<template>
  <div class="static preparation">
	<div class="logo-left">
	  <a href="/storesafe" target="_parent">
		<img src="@/assets/images/storesafe-logo.png" width="100%" alt="StoreSafe logo" />
	  </a>
	</div>
	<h1>{{ $t('preparation.page_title') }}</h1>
  </div>

  <div class="static-grey">
	{{ $t('preparation.intro_text') }}
  </div>
  <div class="static-white">

	<div class="static-split">
	  <div class="split-image">
		<img src="@/assets/images/prep_shelving.jpg" alt="Ingredient bins" class="rounded">
	  </div>
	  <div class="split-content">
		<h2>{{ $t('preparation.camshelving_elevation_series_wall_shelvi') }}</h2>
		<p>{{ $t('preparation.food_safety_culture_starts_at_the_prep_t') }}</p>
		<a href="https://www.cambro.com/Products/shelving/camshelving-elevation-series-wall-shelving/standard-station-kits/EWS36PREP110" target="_blank" class="learn-more">
		<button @mouseover="isHovered = true"
				@mouseleave="isHovered = false"
				:class="{ 'hovered': isHovered }">
		  {{ $t('preparation.learn_more_btn') }}
		</button></a>
	  </div>
   </div>
   
   
   <div class="static-split red-line">
	   <div class="split-image">
		 <img src="@/assets/images/prep_trolley.jpg" alt="Ingredient bins">
	   </div>
	   <div class="split-content">
		 <h2>{{ $t('preparation.mobile_trolleys_6040_and_gn_food_pan_tro') }}</h2>
		 <p>{{ $t('preparation.transport_product_quickly_quietly_and_al') }}</p>
		 <a href="https://www.cambro.com/Products/food-and-salad-bars/prep-and-transport-racks/ultimate-sheet-pan-rack/UPR1826F20580" target="_blank" class="learn-more">
		 <button @mouseover="isHovered = true"
				 @mouseleave="isHovered = false"
				 :class="{ 'hovered': isHovered }">
		   {{ $t('preparation.learn_more_ultimate_sheet_pan_rack') }}
		 </button></a>
		 <a href="https://www.cambro.com/Products/food-and-salad-bars/prep-and-transport-racks/camshelving-gn-food-pan-trolleys/UGNPR11F18480" target="_blank" class="learn-more">
		  <button @mouseover="isHovered = true"
				  @mouseleave="isHovered = false"
				  :class="{ 'hovered': isHovered }">
			{{ $t('receiving.learn_more_btn')}}
		  </button></a>
	   </div>
	</div>
	
	<div class="static-testimonial">
		<div class="quote-top"><img src="@/assets/images/quote-top.jpg" /></div>
		<div class="testimonial-quote">{{ $t('preparation.now_that_we_have_the_cambro_trolleys_its')}}&quot;</div>
		<div class="testimonial-pic"><img src="@/assets/images/prep_testimonial-bill-stitt.jpg" /></div>
		<div class="testimonial-name"><a href="https://blog.cambro.com/2023/02/28/bill-es-small-batch-bacon/ " target="_blank">{{ $t('preparation.bill_stitt_owner_of_billes_small_batch_b')}}</a></div>
	</div>
	 
   
	<div class="static-split red-line">
		<div class="split-image">
		<img src="@/assets/images/prep_camwear.jpg" alt="Ingredient bins">
		</div>
		<div class="split-content">
		<h2>{{ $t('preparation.clear_and_translucent_food_pans') }}</h2>
		<p>{{ $t('preparation.hold_ingredients_safely_on_the_prep_tabl') }}</p>
		<a href="https://www.cambro.com/Products/food-pans-and-lids/food-pans/camwear-pans/" target="_blank" class="learn-more">
		<button @mouseover="isHovered = true"
				@mouseleave="isHovered = false"
				:class="{ 'hovered': isHovered }">
			{{ $t('preparation.learn_more_camwear_pans') }}
		</button></a>
		<a href="https://www.cambro.com/Products/food-pans-and-lids/translucent-food-pans/translucent-food-pans/" target="_blank" class="learn-more">
		<button @mouseover="isHovered = true"
				@mouseleave="isHovered = false"
				:class="{ 'hovered': isHovered }">
			{{ $t('preparation.learn_more_translucent_food_pans') }}
		</button></a>
		</div>
	</div>
	 
	<div class="static-testimonial">
		<div class="quote-top"><img src="@/assets/images/quote-top.jpg" /></div>
		<div class="testimonial-quote">{{ $t('preparation.we_lay_the_mozzarella_balls_out_and_we_g')}}&quot;</div>
		<div class="testimonial-pic"><img src="@/assets/images/prep_testimonial-1.png" /></div>
		<div class="testimonial-name"><a href="https://blog.cambro.com/2023/01/25/righteous-slice/" target="_blank">{{ $t('preparation.bill_crawford_founder_of_righteous_slice')}}</a></div>
	</div>
	 
	 
	<div class="static-split red-line">
		<div class="split-image">
		  <img src="@/assets/images/prep_h-pan.jpg" alt="CamSquares">
		</div>
		<div class="split-content">
		  <h2>{{ $t('preparation.hpan_high_heat_food_pans') }}</h2>
		  <p>{{ $t('preparation.from_flash_freezing_to_reheating_and_dra') }}</p>
		  <a href="https://www.cambro.com/Products/food-pans-and-lids/h-pan-high-heat-colander-food-pans/" target="_blank" class="learn-more">
		  <button @mouseover="isHovered = true" 
				  @mouseleave="isHovered = false"
				  :class="{ 'hovered': isHovered }">
			{{ $t('receiving.learn_more_btn')}}
		  </button></a>
		</div>
	 </div>
	 
	 <div class="static-testimonial">
		<div class="quote-top"><img src="@/assets/images/quote-top.jpg" /></div>
		<div class="testimonial-quote">{{ $t('preparation.we_will_make_about_40_gallons_of_sauce_a')}}&quot;</div>
		<div class="testimonial-pic"><img src="@/assets/images/prep_testimonial-2.png" /></div>
		<div class="testimonial-name"><a href="https://blog.cambro.com/2024/03/25/the-old-spaghetti-factory-protects-famous-sauce-utilizing-cambro-products/" target="_blank">{{ $t('preparation.brian_sullivan_director_of_kitchen_opera')}}</a></div>
	</div>
	
	 
	 <div class="static-split red-line">
		 <div class="split-image">
		   <img src="@/assets/images/prep_measuring-cups.png" alt="CamSquares">
		 </div>
		 <div class="split-content">
		   <h2>{{ $t('preparation.measuring_cups') }}</h2>
		   <p>{{ $t('preparation.measuring_cups_not_only_improve_accuracy') }}</p>
		   <a href="https://www.cambro.com/Products/food-storage/measuring-cups-and-scoops/" target="_blank" class="learn-more">
		   <button @mouseover="isHovered = true" 
				   @mouseleave="isHovered = false"
				   :class="{ 'hovered': isHovered }">
			 {{ $t('receiving.learn_more_btn')}}
		   </button></a>
		 </div>
	  </div>
	  
	  <div class="static-split red-line">
		<div class="split-image">
		  <img src="@/assets/images/storage_ingredient-bins.jpg" alt="Ingredient bins">
		</div>
		<div class="split-content">
		  <h2>{{ $t('preparation.ingredient_binsslidinglid_ice_caddies') }}</h2>
		  <p>{{ $t('preparation.store_bulk_dry_ingredients_and_ice_in_id') }}</p>
		  <a href="https://www.cambro.com/Products/food-storage/mobile-ingredient-bins/ingredient-bins/" target="_blank" class="learn-more">
		  <button @mouseover="isHovered = true" 
				  @mouseleave="isHovered = false"
				  :class="{ 'hovered': isHovered }">
			{{ $t('preparation.learn_more_ingredient_bins')}}
		  </button></a>
		  <a href="https://www.cambro.com/Products/beverage-bars/ice-caddies/slidinglid-ice-caddies/" target="_blank" class="learn-more">
		  <button @mouseover="isHovered = true" 
				  @mouseleave="isHovered = false"
				  :class="{ 'hovered': isHovered }">
			{{ $t('preparation.learn_more_sliding_lid_ice_caddies')}}
		  </button></a>
		</div>
	 </div>
	  
	  <div class="sub-white">
		  <h1>{{ $t('receiving.other_resources_title') }}</h1>
		  <div class="home-categories">
			  <a href="/storesafe/receiving" target="_parent" class="home-cat"><div class="cat-receiving"></div></a>
			  <a href="/storesafe/storage" target="_parent" class="home-cat"><div class="cat-storage"></div></a>
			  <a href="#" class="home-cat dimmed"><div class="cat-prep"></div></a>
			  <a href="/storesafe/service" target="_parent" class="home-cat"><div class="cat-service"></div></a>
			  <a href="/storesafe/warewashing" target="_parent" class="home-cat"><div class="cat-warewashing"></div></a>
		  </div>
	  </div>
	  
  </div>


</template>

